import api from '~/utils/api';
import { ClaimType } from '~/utils/constants';
import { makeLineItemClaimLoaderWithReason } from '~/utils/routing';

const { loader, useLoaderData } = makeLineItemClaimLoaderWithReason(
  ({
    context: {
      claim,
      settings: { storefrontId, isClaimImageFromCustomerRequired },
    },
  }) =>
    api
      .checkAfterReasonSelection({
        params: { storefrontId },
        query: {
          quantity: claim.quantity,
          lineItemIdFromPlatform: claim.lineItem.idFromPlatform,
          lineItemId: claim.lineItem.id,
          reasonId: claim.reason.id,
          claimType: claim.claimType,
          reasonCategoryCode: claim.reason.category,
          ...(claim.reason.detail && {
            reasonDetailId: claim.reason.detail.id,
          }),
        },
      })
      .then(({ eventCustomFields }) => {
        const requireAssets =
          eventCustomFields?.params.isMediaUploadRequired ??
          (isClaimImageFromCustomerRequired ||
            claim.claimType === ClaimType.warranty);

        // if require assets is true,
        // then the minimumMediaUploadAmount is the provided value or 1
        // if require assets is false, then the minimumMediaUploadAmount is 0
        const requiredMediaCount =
          requireAssets ?
            (eventCustomFields?.params.minimumMediaUploadAmount ?? 1)
          : 0;

        return {
          customFields: eventCustomFields?.params.customFields ?? [],
          mediaUploadInstructions:
            eventCustomFields?.params.mediaUploadInstructions,
          requiredMediaCount,
          showDefaultCommentField:
            eventCustomFields?.params.showDefaultCommentField ?? true,
          claim,
          isDefaultCommentFieldRequired:
            eventCustomFields?.params.showDefaultCommentField ?
              Boolean(eventCustomFields.params.isDefaultCommentFieldRequired)
            : false,
          uploadFileInfo: {
            storefrontId,
            destination: 'crewClaimImg' as const,
          },
        };
      }),
);

export { loader, useLoaderData };
